import styled from "styled-components";
import { Select, Radio, Slider, Button, Checkbox, Row, Col } from "antd";

type FilterOptionProps = {
  "data-chosen": boolean;
};

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilterMenuRow = styled(Row)`
  margin: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FilterMenuCol = styled(Col)`
  margin-top: 8px;
  margin-bottom: 8px;
  justify-content: flex-start;
`;

export const FilterLabel = styled.div`
  height: 36px;
  color: #1070b6;
  font-size: 16px;
  font-weight: bold;
  margin: 0px 8px 8px 0px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const FilterSelect = styled(Select)`
  height: 36px;
  font-size: 14px;
  color: black;
  white-space: normal;

  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 100%;
    background-color: #ffffff;
    justify-content: center;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0px 16px;
  }

  &.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector::placeholder {
    color: #707070;
  }

  & .ant-select-arrow {
    margin-right: 8px;
  }

  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    justify-content: center;
    display: flex;
    align-items: center;
  }
`;

export const LevelSelect = styled(FilterSelect)`
  width: 100%;
`;

export const ClassTypeFilter = styled(Radio.Group)`
  height: 36px;
  display: flex;
  flex-direcion: row;

  & .ant-radio-button-wrapper {
    height: 100%;
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #707070;
    padding: 0px 4px;
  }

  & .ant-radio-button-wrapper-checked {
    background-color: #1070b6;
    color: white;
  }
`;

export const FilterOption = styled.div`s
  padding: 0px 8px;
  height: 36px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  margin: 0px 2px;
  font-size: 14px;
  cursor: pointer;
  background-color: ${(props: FilterOptionProps) =>
    props["data-chosen"] ? "#1070b6" : "white"};
  color: ${(props: FilterOptionProps) =>
    props["data-chosen"] ? "white" : "#707070"};
  border: ${(props: FilterOptionProps) =>
    props["data-chosen"] ? "2px solid #1070b6" : "2px solid #E4E4E4"};
  transition: background-color 0.24s;
`;

export const DayOption = styled(FilterOption)`
  width: 14.25%;
`;

export const DayFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TimeFilter = styled(Slider)`
  display: flex;
  flex-grow: 1;
  margin: 14px 6px 0;

  & .ant-slider-rail {
    background-color: #e4e4e4;
  }

  & .ant-slider-track {
    background-color: #1070b6;
  }

  & .ant-slider-handle {
    background-color: #1070b6;
    border: solid 2px #1070b6;
  }

  & .ant-slider-dot-active {
    border-color: #1070b6;
  }

  & .ant-slider-mark-text {
    bottom: 16px;
    font-size: 12px;
    font-weight: bold;
    color: #1070b6;
  }
`;

export const MenuButton = styled(Button)`
  background-color: #d3e8ff;
  padding: 0px 6px;
  width: 100%;
  color: #1070b6;
  border-width: 0;
  font-weight: bold;
  font-size: 16px;
  height: 36px;
  transform: scaleY(0.95);

  &:focus {
    background-color: #d3e8ff;
    color: #1070b6;
  }

  &:hover {
    background-color: #a9c8ea;
    color: #1070b6;
  }
`;

export const AdvancedFilterMenuRow = styled(FilterMenuRow)`
  align-items: center;
`;

export const FilterCheckBox = styled(Checkbox)`
  color: #707070;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;

  & .ant-checkbox {
    margin: 0px;
    width: 24px;
    height: 24px;
  }

  & .ant-checkbox .ant-checkbox-inner {
    margin: 0px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .ant-checkbox-inner::after {
    left: 30%;
  }

  & .ant-checkbox-input {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .ant-checkbox + span {
    padding: 0px;
    margin: 0px 0px 0px 8px;
  }

  & .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #1070b6;
  }
`;

export const CategoriesFilter = styled(Row)`
  margin-bottom: -8px;
  display: flex;
  flex-direction: row;
`;

export const CategoryOption = styled(FilterOption)`
  margin-bottom: 8px;
  padding: 0px 8px;
  flex-grow: 1;
`;

export const StudiedTopicsSelect = styled(FilterSelect)`
  width: 100%;
`;

export const TopicSelect = styled(FilterSelect)`
  width: 100%;
`;

export const CharacterSelect = styled(FilterSelect)`
  display: flex;
  margin-right: 24px;
  width: 100%;
`;

export const CityFilter = styled(CategoriesFilter)``;

export const CityOption = styled(FilterOption)`
  flex-grow: 1;
`;

export const LanguageSelect = styled(FilterSelect)`
  width: 100%;
  font-weight: normal;
`;
